export default {
  updateTab: (data) => ({
    position: data,
  }),
}
